"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ui = require("@alycecom/ui");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _constants = require("../../CreateGift/constants");

var _useNeedMoreInfo3 = _interopRequireDefault(require("../hooks/useNeedMoreInfo"));

var _Product = _interopRequireDefault(require("./Product"));

var _NeedMoreInfo = _interopRequireDefault(require("./NeedMoreInfo"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    subTitle: {
      fontSize: '12px',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginTop: spacing(1),
      marginBottom: spacing(1)
    }
  };
});

var LatestGift = function LatestGift(_ref2) {
  var currentGift = _ref2.currentGift,
      latestGift = _ref2.latestGift,
      contact = _ref2.contact,
      onCancelGift = _ref2.onCancelGift;
  var classes = useStyles();
  var isCurrentNeedMoreInfo = !!currentGift && currentGift.statusId === _constants.giftStatuses.NEED_MORE_INFO;
  var isLatestNeedMoreInfo = !!latestGift && latestGift.statusId === _constants.giftStatuses.NEED_MORE_INFO;
  var isLatestHasProduct = !!latestGift && !!latestGift.product;
  var isDisplayCurrentGift = isCurrentNeedMoreInfo || !isLatestNeedMoreInfo && !isLatestHasProduct;
  var gift = isDisplayCurrentGift ? currentGift : latestGift;

  var _useNeedMoreInfo = (0, _useNeedMoreInfo3.default)(gift && gift.id),
      _useNeedMoreInfo2 = (0, _slicedToArray2.default)(_useNeedMoreInfo, 3),
      sendMoreInfo = _useNeedMoreInfo2[0],
      needMoreInfoIsLoading = _useNeedMoreInfo2[1],
      needMoreInfoErrors = _useNeedMoreInfo2[2];

  var handleCancelGift = (0, _react.useCallback)(function () {
    if (gift) {
      onCancelGift(gift.id);
    }
  }, [gift, onCancelGift]);

  if (!gift) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    color: "dividerLight",
    my: 2
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: classes.subTitle,
    variant: "subtitle2"
  }, isDisplayCurrentGift ? 'Current gift' : 'Latest gift'))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, gift.product && /*#__PURE__*/_react.default.createElement(_Product.default, {
    name: gift.product.name,
    image: gift.product.image,
    status: gift.history[0].label,
    date: gift.history[0].action_date
  }), gift.statusId === _constants.giftStatuses.NEED_MORE_INFO && /*#__PURE__*/_react.default.createElement(_NeedMoreInfo.default, {
    contact: contact,
    adminNote: gift.adminNote,
    onSubmit: sendMoreInfo,
    onCancelGift: handleCancelGift,
    isLoading: needMoreInfoIsLoading,
    errors: needMoreInfoErrors
  }))), /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    color: "dividerLight",
    my: 2
  }));
};

LatestGift.propTypes = {
  contact: _propTypes.default.objectOf(_propTypes.default.string).isRequired,
  onCancelGift: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  latestGift: _propTypes.default.object,
  // eslint-disable-next-line react/forbid-prop-types
  currentGift: _propTypes.default.object
};
LatestGift.defaultProps = {
  onCancelGift: function onCancelGift() {},
  latestGift: null,
  currentGift: null
};
var _default = LatestGift;
exports.default = _default;